import { Component } from '@angular/core';

@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
    <span class="created-by">
      صنع بحب ♥ من قبل  
      <b>
      <a href="http://b-wire.co"target="_blank">شركة بي واير للبرمجيات</a>
      </b> ♥ B-Wire<b>
        <a href="#" target="http://b-wire.co/"></a>
      </b>
    </span>
    <div class="socials">
      <a  href="https://www.facebook.com/b.wire.xyz/" target="_blank" class="ion ion-social-facebook"><i class="fa fa-bomb ng-star-inserted"></i></a>
      <a href="https://www.linkedin.com/company/b-wire/" target="_blank" class="ion ion-social-linkedin"></a>
    </div>
  `,
})
export class FooterComponent {
}
